<script setup lang="ts">
import {onMounted, onUnmounted} from 'vue';
import {RouterView} from 'vue-router';
import {CircleCheck, CircleX, Inbox} from 'lucide-vue-next';
import {AvailabilityState} from 'common';
import AppShell from '@/views/shell/AppShell.vue';
import {type NavItem} from '@/views/shell/navItems.js';
import {fetchAndSetState, startStatePolling, stateForReporters, stopStatePolling} from '@/base/TMP_globalState.js';
import {done, loadingState, reload} from '@/base/loadingState.js';
import LoadingStateView from '@/views/general/LoadingStateView.vue';

// the three badge counts are still placeholders; replace them with real data as needed
const ITEMS: NavItem[] = [
    {label: 'te doen', to: '/accept/te-doen', icon: Inbox, badge: 0, badgeColor: 'blue'},
    {label: 'geaccepteerd', to: '/accept/geaccepteerd', icon: CircleCheck, badge: 0, badgeColor: 'green'},
    {label: 'afgewezen', to: '/accept/afgewezen', icon: CircleX, badge: 0, badgeColor: 'red'},
];

onMounted(async () => {
    await reload();
    await fetchAndSetState();
    startStatePolling();
});

onUnmounted(() => {
    stopStatePolling();
});
</script>

<template>
    <AppShell landing="Acceptatie" :items="ITEMS">
        <LoadingStateView :state="loadingState" :stateForReporters="stateForReporters"/>
        <RouterView v-if="done && stateForReporters !== AvailabilityState.closed"/>
    </AppShell>
</template>
